export const CareCostsHeader = () => (
  <header>
    <h1 className="text-3xl md:text-4xl font-semibold font-recoleta leading-tight">
      Understand the cost of care in your area
    </h1>
    <p className="mt-4 text-base font-normal leading-relaxed text-muted-foreground font-termina">
      Long-term care costs vary widely by location and type. Use this tool to see what
      families in your area are typically paying — a trusted starting point as you
      research options for someone you love.
    </p>
  </header>
);
